export default __webpack_public_path__ + "static/media/a037-student-t3-6.a5d68669.svg";